import React from "react";
import "./index.scss";

const NotFound = () => (
  <div id="main">
    <div className="fof">
      <h1>Error 404</h1>
      <div className="btn">
        <a href="/farms">Return to Home</a>
      </div>
    </div>
  </div>
);

export default NotFound;
